<template>
    <div class="sizes" v-if="sizes.length > 0 && this.sizes[0] !== null && sizes.some((size) => size !== '')">
        <div class="sizes__title">{{ title }}</div>
        <div class="sizes__items">
            <div class="sizes__item" v-for="(item, index) in sizes" :key="index" :class="{ active: activeIndex === index }" @click="selectSize(index)">
                {{ item }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SizesProduct",
    props: {
        title: String,
        sizes: Array,
    },
    data() {
        return {
            activeIndex: 0,
        };
    },
    methods: {
        selectSize(index) {
            console.log(this.sizes);
            this.activeIndex = index;
            this.$emit("selected", this.sizes[index]);
        },
    },
};
</script>

<style></style>
